import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import profileImage from "../../assets/profile.png";
import { log } from "../../helper/helper";
import { getAuth, signOut } from "firebase/auth";
import SidebarMenu from "./SidebarMenu";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

function NavBar({ props, isExpanded, setIsExpanded }) {
  const name = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const avatar = localStorage.getItem("avatar");
  const [imageUrl, setImageUrl] = useState("");
  const storage = getStorage();
  const starsRef = ref(storage, avatar);

  useEffect(() => {
    setTimeout(() => {}, 3000);
    log(avatar);
    if (avatar !== null && getAuth() !== null) {
      getDownloadURL(starsRef)
        .then((url) => {
          setImageUrl(url);
        })
        .catch((error) => {
          log(error);
        });
    } else {
      const auth = getAuth();
      signOut(auth).then(() => {
        return props.history.replace("/login");
      });
    }

    if (name === null && lastName === null) {
      const auth = getAuth();
      signOut(auth).then(() => {
        return props.history.replace("/login");
      });
    }
  }, []);

  const toggleNavbar = () => {
    setIsExpanded((prev) => {
      const newState = !prev;
      const mainSection = document.querySelector(".main-data-section");
      if (mainSection) {
        mainSection.classList.toggle("expanded", newState);
      }
      return newState;
    });
  };
  return (
    <div className={`sidebar-section ${isExpanded ? "expanded" : ""}`}>
      <div className="navbar">
        <div className="expand-menu">
          <button className="expand-btn" onClick={toggleNavbar}>
            {isExpanded ? <RightOutlined /> : <LeftOutlined />}
          </button>
        </div>
        <div className="userInfo">
          <figure>
            <img src={imageUrl !== "" ? imageUrl : profileImage} alt="avatar" />
          </figure>
          <figcaption>
            <div className="userName">{name + " " + lastName}</div>
            <div className="userLevel">Admin</div>
          </figcaption>
        </div>
        <div className="line"></div>

        <SidebarMenu />
      </div>
    </div>
  );
}

export default NavBar;
